<template>
  <v-row>
    <v-col>
      <VTextField
        v-model="currentName"
        :label="$t('graphics.graphicName')"
        :rules="{ required: true, min: 1, max: 200 }"
        outlined
        @input="updateData"
      />
    </v-col>
  </v-row>
</template>

<script>
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';

export default {
    components: {
        VTextField,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        isEdition: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            currentName: '',
        };
    },
    created() {
        if (this.isEdition) {
            this.currentName = this.name;
        }
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.currentName);
        },
    },
};
</script>
